import { AppCuesService } from 'modules/shared/AppCuesService';
import { LSLastUrlTry } from 'modules/account';
class LogoutController {
    static $inject = ['AuthenticationService', 'BlipService', 'SegmentService', 'OidcService', '$state'];
    constructor(AuthenticationService, BlipService, SegmentService, OidcService, $state) {
        'ngInject';
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.SegmentService = SegmentService;
        this.OidcService = OidcService;
        this.$state = $state;
        this.logout();
    }
    async logout() {
        let returnUrl;
        if (this.$state.params.tenantId) {
            returnUrl = `${window.location.origin}/application?tenant-invitation=${this.$state.params.tenantId}`;
        }
        if (this.$state.params.shortName) {
            returnUrl = `${window.location.origin}/application/detail/${this.$state.params.shortName}/home`;
        }
        localStorage.removeItem(LSLastUrlTry);
        if (!this.AuthenticationService.isAuthenticated()) {
            this.$state.go('anon.login');
        }
        this.BlipService.close();
        AppCuesService.instance.user = undefined;
        this.SegmentService.resetAccount();
        //FEATURE_TOGGLE
        if (this.AuthenticationService.auth && this.AuthenticationService.auth.tokenType !== 'Bearer') {
            this.AuthenticationService.logout();
            this.$state.go('anon.login');
        }
        this.AuthenticationService.logout();
        const currentDomain = `${window.location.origin}/`; // Needs to be dynamic due to custom workspaces domains
        await this.OidcService.getInitializedPromise();
        await this.OidcService.UserManager.signoutRedirect({
            post_logout_redirect_uri: returnUrl || currentDomain.slice(0, -1),
        });
        await this.OidcService.UserManager.removeUser();
        this.OidcService.clearOidcStorageData();
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
LogoutController.$inject = ['AuthenticationService', 'BlipService', 'SegmentService', 'OidcService', '$state'];
export default LogoutController;
